import {computed, DestroyRef, inject, signal} from '@angular/core';
import {Observable} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LoadingSpec} from '../models/loading.model';

export abstract class BaseFacade {
  protected destroyRef = inject(DestroyRef);
  protected loadingSignal = signal<LoadingSpec>({state: false});

  readonly loading = this.loadingSignal.asReadonly();
  readonly isLoading = computed(() => this.loading().state);
  readonly loadingProgress = computed(() => this.loading().progress);
  readonly loadingMessage = computed(() => this.loading().message);

  protected startLoading(message: string = 'Ładowanie...', progress?: number): void {
    this.loadingSignal.set({
      state: true,
      message,
      progress
    });
  }

  protected updateLoadingProgress(progress: number, message?: string): void {
    const current = this.loadingSignal();
    this.loadingSignal.set({
      state: true,
      progress,
      message: message || current.message
    });
  }

  protected stopLoading(): void {
    this.loadingSignal.set({state: false});
  }

  protected withAutoCleanup<T>(source: Observable<T>): Observable<T> {
    return source.pipe(takeUntilDestroyed(this.destroyRef));
  }
}
